import styled from 'styled-components'
import React from 'react'
import MatchMedia from 'react-micro-match-media'
import { Title as T, tokens } from '@arvoreeducacao/bonsai-ds'
import { sizes } from 'config/ui'

import Modal from '../Modal'

export const ModalStyled = styled(Modal)`
  width: 100%;
  max-width: 550px;
  border-radius: ${tokens.radius.radius_10}px;
  div:first-child {
    padding: 0;
  }
`

export const Container = styled.div`
  @media (max-width: ${sizes.mScreen}px) {
    margin: 0;
  }
`

export const Image = styled.img`
  width: 100%;
  margin-bottom: ${tokens.spacing.spacing_56}px;
  border-top-left-radius: ${tokens.radius.radius_10}px;
  border-top-right-radius: ${tokens.radius.radius_10}px;
  object-fit: cover;
  min-height: 220px;
`

export const Title = styled(T)`
  text-align: center;
  font-size: ${tokens.sizes.h[4].tablet};
  line-height: 30px;
  color: ${tokens.colors.black6};
  margin: 0;

  @media (max-width: ${tokens.sizes.lgScreen}px) {
    font-size: ${tokens.sizes.h[5].tablet};
  }
`

const Text = styled.p`
  font-size: ${tokens.sizes.text}px;
  line-height: 30px;
  color: ${tokens.colors.black6};
  margin-top: ${tokens.spacing.spacing_8}px;
  text-align: center;
  padding-left: ${tokens.spacing.spacing_32}px;
  padding-right: ${tokens.spacing.spacing_32}px;

  @media (max-width: ${tokens.sizes.lgScreen}px) {
    font-size: ${tokens.sizes.text}px;
    line-height: 30px;
    padding-left: ${tokens.spacing.spacing_16}px;
    padding-right: ${tokens.spacing.spacing_16}px;
  }
`

export const TextResponsive = ({ desktopText, mobileText }) => (
  <MatchMedia query={`(min-width: ${tokens.sizes.smScreen}px)`}>
    {bigScreen =>
      bigScreen ? <Text>{desktopText}</Text> : <Text>{mobileText}</Text>
    }
  </MatchMedia>
)

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 48px 0 35px 0;
`
